module.exports = __webpack_public_path__ + "static/img/northFace1.6890f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/northFace1.png
// module id = wzfb
// module chunks = 2